import { useState, useCallback } from 'react';
import { useCatalog } from '../hooks/useCatalog';
import { MeasurementData } from '../contexts/CatalogContext';
import { logger } from '../utils/logger';

export const useCatalogMeasurements = (catalogItemId?: string, ownerId?: string | null) => {
  const { saveMeasurements, getMeasurements, error } = useCatalog();
  const [measurements, setMeasurements] = useState<MeasurementData | null>(null);
  const [localLoading, setLocalLoading] = useState(false);

  const loadMeasurements = useCallback(async (id?: string) => {
    const itemId = id || catalogItemId;
    if (!itemId) return;

    setLocalLoading(true);
    try {
      const data = await getMeasurements(itemId, ownerId);
      setMeasurements(data);
      return data;
    } catch (err) {
      logger.error('Failed to load measurements', err);
      throw err;
    } finally {
      setLocalLoading(false);
    }
  }, [catalogItemId, getMeasurements, ownerId]);

  const updateMeasurements = useCallback(async (data: MeasurementData, id?: string) => {
    const itemId = id || catalogItemId;
    if (!itemId) throw new Error('No catalog item ID provided');

    setLocalLoading(true);
    try {
      await saveMeasurements(itemId, data, ownerId);
      // Don't automatically update local state to prevent overwriting user input
      // setMeasurements(data);
    } catch (err) {
      logger.error('Failed to save measurements', err);
      throw err;
    } finally {
      setLocalLoading(false);
    }
  }, [catalogItemId, saveMeasurements, ownerId]);

  return {
    measurements,
    loadMeasurements,
    updateMeasurements,
    isLoading: localLoading,
    error
  };
};
